export default __webpack_public_path__ + "static/media/female_center_chest.7df0e483.png";